export const filterData = [
  {
    id: "1",
    title: "Assignments",
  },
  {
    id: "2",
    title: "Theory Topics",
  },
  {
    id: "3",
    title: "Interview questions",
  },
  
];
export const apiUrl = "https://osl-backend.onrender.com/api/assignment/getAllAssignments";